import React from 'react';

const TimerAnimation = ({ time, duration, isShowTimer, timerDuration, isAnimationOn }) => {
  return (
    <>
      {time && isShowTimer && isAnimationOn ? (
        <div className='svg-wrp'>
          <svg
            className='circle-chart'
            viewBox='0 0 33.83098862 33.83098862'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle
              className='circle-chart-background'
              cx='16.91549431'
              cy='17'
              fill='none'
              r='11'
              stroke='rgba(255,255,255, 0.4)'
              strokeWidth='5.5'
            />
            <circle
              className='round-loader circle-chart-circle'
              cx='16.91549431'
              cy='17'
              fill='none'
              r='11'
              stroke='#ffffff'
              strokeWidth='5.5'
              style={{
                animationDuration: `${duration}s`,
                ...(duration !== timerDuration && timerDuration
                  ? { animationDelay: `-${duration - timerDuration}s` }
                  : {}),
              }}
            />
          </svg>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default TimerAnimation;
